.documentsContainer {
	display: flex;
	flex-direction: column;
	gap: 12px;
	max-height: 420px;
	overflow: auto;
	padding-right: 4px;
}

.modalSubtitle {
	font-size: 13px;
	line-height: 1.4;
	color: #5f6f85;
}

.documentsList {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.documentItem {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	padding: 12px;
	border: 1px solid #e6ecf5;
	border-radius: 12px;
	background: linear-gradient(180deg, #ffffff 0%, #f9fbff 100%);
}

.fileIdentity {
	display: flex;
	align-items: center;
	gap: 12px;
	min-width: 0;
}

.fileIconWrap {
	width: 34px;
	height: 34px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #3251d0;
	background: #ebf0ff;
	border-radius: 10px;
}

.fileTexts {
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 6px;
}

.documentName {
	font-weight: 600;
	color: #203147;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.fileMetaRow {
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 12px;
	color: #63748b;
	flex-wrap: wrap;
}

.fileMetaChip {
	padding: 2px 8px;
	border-radius: 999px;
	background: #eef2ff;
	color: #384db9;
	text-transform: uppercase;
	font-weight: 600;
	font-size: 10px;
	letter-spacing: 0.3px;
}

.fileMetaDot {
	color: #9aa7ba;
}

.fileMetaText {
	display: inline-flex;
	align-items: center;
	gap: 4px;
}

.openFileButton {
	border: 1px solid #dbe4f4;
	background: #ffffff;
	padding: 7px 10px;
	border-radius: 8px;
	font-size: 12px;
	font-weight: 600;
	color: #1f4fd6;
	display: inline-flex;
	align-items: center;
	gap: 6px;
	cursor: pointer;
	transition: all 0.2s ease;
}

.openFileButton:hover {
	border-color: #b9c9eb;
	background: #f6f9ff;
}

.emptyDocuments {
	padding: 18px 14px;
	border: 1px dashed #d5dfef;
	border-radius: 10px;
	background: #fbfdff;
	color: #62748a;
	text-align: center;
}
